import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { getActiveAlgorandWallet } from "../app/algorand/algorandSlice";
import { getUser, logout } from "../app/auth/authSlice";
import { getLastNetwork } from "../app/network/networkSlice";
import { getActiveRippleWallet } from "../app/ripple/rippleSlice";
import { HTTP_STATUS } from "../constants/httpStatus";
import { networkDataToReturn } from "../constants/network";
import useSubmit from "./Submit";


function AuthHook() {
    const dispatch = useDispatch()
    const history = useHistory()
    const network = useSelector(state => state.network.network)
    const { 
        status: activeWalletStatus, 
        data: activeWalletData 
    } = useSelector(networkDataToReturn[network.toLowerCase()])

    const { 
        data: lastNetworkData, 
        status: lastNetworkStatus, 
        error: lastNetworkError 
    } = useSelector(state => state.network.lastNetwork)

    const { handleSubmit } = useSubmit()

    const activeWalletToGet = {
        ALGORAND: getActiveAlgorandWallet,
        RIPPLE: getActiveRippleWallet
    }

    const getUserSuccessCallback = () => {
        handleSubmit(getLastNetwork())
    }

    const getUserErrorCallback = () => {
        dispatch(logout())
        history.push('/login')
        // window.location.replace('https://mintengine.org')
    }

    useEffect(() => {
        if (localStorage.getItem('mint-engine')) {
          handleSubmit(getUser(), getUserSuccessCallback, getUserErrorCallback);
        }
    }, [])

    useEffect(() => {
        if (lastNetworkStatus === HTTP_STATUS.FULFILLED) {
            handleSubmit(activeWalletToGet[network]())
        }
    }, [lastNetworkStatus, dispatch, network])

    useEffect(() => {
        if (activeWalletStatus === HTTP_STATUS.FULFILLED && !activeWalletData?.address) {
            history.push('/wallet-setup')
        }
    }, [activeWalletData, activeWalletStatus, history])

    return null
}

export default AuthHook